import Keycloak from 'keycloak-js';

export const keycloakConfig = {
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    url: process.env.REACT_APP_KEYCLOAK_URL,
    sslRequired: "none",
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    publicClient: true,
    confidentialPort: 0,
    enableCors:true,
    disableTrustManager: true,
}

export const keycloak = new Keycloak(keycloakConfig);

export const updateToken = (successCallback) => {
    return keycloak.updateToken(300)
        .then(successCallback)
        .catch(keycloak.login)
};

export const isAuthenticated = ({keycloak, keycloakInitialized}) => {
    return keycloakInitialized && keycloak.authenticated;
}

export const isAutherized = (roles) => {
    if (keycloak && roles) {
        return roles.some(r => {
            const realm =  keycloak.hasRealmRole(r);
            const resource = keycloak.hasResourceRole(r);
            return realm || resource;
        });
    }
    return roles !== null ? false : true;
}

const keycloakInfoAccess = () => keycloak && keycloak.tokenParsed;

export const getUsername = () => keycloakInfoAccess() ? keycloak.tokenParsed.preferred_username.toUpperCase() : '';
export const getFirstName = () => keycloakInfoAccess() ? keycloak.tokenParsed.given_name : '';
export const getLastName = () => keycloakInfoAccess() ? keycloak.tokenParsed.family_name : '';
export const getFullName = () => keycloakInfoAccess() ? keycloak.tokenParsed.name : '';

export const getCoordenadorUsername = () => keycloakInfoAccess() ? keycloak.tokenParsed.preferred_username.replace("subcr_", "").toUpperCase() : '';
export const getCoordenadorUF = () => getCoordenadorUsername().substring(0, 2);
export const getCoordenadorRegiao = () => getCoordenadorUsername();

export const getApoioSecretarialUsername = () => keycloakInfoAccess() ? keycloak.tokenParsed.preferred_username.substring(0, getUsername().indexOf("_")).toUpperCase() : '';
export const getApoioSecretarialUF = () => getApoioSecretarialUsername().substring(0, 2);
export const getApoioSecretarialRegiao = () => getApoioSecretarialUsername();

export const removeKcTokenLocalStorage = () => {
    localStorage.removeItem('kc_token');
    localStorage.removeItem('kc_refreshToken');
    localStorage.removeItem('kc_idToken');
}

export const handleLogin = (redirectUrl) => {
    removeKcTokenLocalStorage();
    keycloak.login({ redirectUri: redirectUrl || window.location.origin });
};

export const handleLogout = (redirectUrl) => {
    removeKcTokenLocalStorage();
    keycloak.logout({ redirectUri: redirectUrl || window.location.origin });
};

export const handleAutoLogin = async (username, password, redirectUrl) => {
    try {
        const params = new URLSearchParams({
            grant_type: 'password',
            client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
            username: username,
            password: password,
            scope: 'openid'
        });

        const response = 
            await fetch(`${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                },
                body: params
            });

        const rawText = await response.text();

        if (!response.ok) {
            console.error("Erro ao Realizar Login Automático: ", rawText);
            handleLogin(redirectUrl);

        } else {
            try {
                const tokens = JSON.parse(rawText);

                if (tokens.access_token) {
                    await keycloak.init({
                        token: tokens.access_token,
                        refreshToken: tokens.refresh_token,
                        idToken: tokens.id_token,
                        onLoad: 'check-sso',
                        checkLoginIframe: false 
                    });

                    localStorage.setItem('kc_token', tokens.access_token);
                    localStorage.setItem('kc_refreshToken', tokens.refresh_token);
                    localStorage.setItem('kc_idToken', tokens.id_token);

                    window.location.href = redirectUrl;
                }
            } catch (error) {
                console.error("JSON Inválido para Realizar Login Automático: ", rawText);
                handleLogin(redirectUrl);
            }
        }
    } catch (error) {
        console.error("Erro ao Realizar Login Automático: ", error);
        handleLogin(redirectUrl);
    }
};

export default keycloak;